import React from 'react';
import { useAuth } from '../context/AuthContext';
import './RequireAnnotator.css';

/**
 * Wraps pages that write to Firestore (annotating, the legacy dictionary
 * editor). Learner pages are public and don't use this. Firestore rules
 * enforce the same thing server-side; this only decides what to render.
 */
function RequireAnnotator({ children }) {
  const { user, isAnnotator, loading, error, signIn, signOut } = useAuth();

  if (isAnnotator) return children;

  let body;
  if (loading) {
    body = <p className="login-subtitle">Checking your access…</p>;
  } else if (!user) {
    body = (
      <>
        <p className="login-subtitle">Annotating is for hoja's annotators. Sign in to continue.</p>
        <button className="login-google-btn" onClick={signIn}>Sign in with Google</button>
      </>
    );
  } else {
    body = (
      <>
        {!error && (
          <div className="login-access-denied">
            {user.email} doesn't have annotator access. Ask the hoja admin to add it.
          </div>
        )}
        <button className="login-google-btn" onClick={signOut}>Sign out</button>
      </>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">🍃</div>
        <h1 className="login-title">hoja</h1>
        {error && <div className="login-error">{error}</div>}
        {body}
      </div>
    </div>
  );
}

export default RequireAnnotator;
